import { useEffect, useState } from 'react';
import { api } from '../../../api/client';
import StaffForm from './StaffForm';
import styles from './StaffPage.module.css';

export default function StaffPage() {
  const [staff, setStaff] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editStaff, setEditStaff] = useState<any>(null);

  const fetchStaff = async () => {
    setLoading(true);
    try {
      const data = await api.get<any[]>('/api/misc/staff');
      setStaff(Array.isArray(data) ? data : []);
    } catch {
      /* ignore */
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchStaff();
  }, []);

  const handleDelete = async (id: string, name: string) => {
    if (!confirm(`¿Eliminar a ${name}? Esta acción no se puede deshacer.`)) return;
    try {
      await api.delete(`/api/misc/staff/${id}`);
      fetchStaff();
    } catch {
      alert('Error al eliminar');
    }
  };

  const openEdit = (member: any) => {
    setEditStaff(member);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditStaff(null);
  };

  const roleLabel = (role: string) => {
    const labels: Record<string, string> = {
      SCHOOL_ADMIN: 'Administrador',
      TEACHER: 'Docente',
      STAFF: 'Personal',
    };
    return labels[role] || role;
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Alta de Personal</h1>
        <button className={styles.addButton} onClick={() => setShowModal(true)}>
          + Nuevo Empleado
        </button>
      </div>

      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <h3>Total Empleados</h3>
          <p>{staff.length}</p>
        </div>
        <div className={styles.statCard}>
          <h3>Administradores</h3>
          <p>{staff.filter((s) => s.role === 'SCHOOL_ADMIN').length}</p>
        </div>
        <div className={styles.statCard}>
          <h3>Docentes</h3>
          <p>{staff.filter((s) => s.role === 'TEACHER').length}</p>
        </div>
        <div className={styles.statCard}>
          <h3>Personal</h3>
          <p>{staff.filter((s) => s.role === 'STAFF').length}</p>
        </div>
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Email</th>
              <th>Teléfono</th>
              <th>Cargo</th>
              <th>Rol</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} style={{ textAlign: 'center' }}>
                  Cargando...
                </td>
              </tr>
            ) : staff.length === 0 ? (
              <tr>
                <td colSpan={7} style={{ textAlign: 'center' }}>
                  No hay personal registrado
                </td>
              </tr>
            ) : (
              staff.map((member) => (
                <tr key={member.id}>
                  <td className={styles.nameCell}>{member.name || '—'}</td>
                  <td>{member.email}</td>
                  <td>{member.phone || '—'}</td>
                  <td>{member.position || '—'}</td>
                  <td>
                    <span className={styles.roleBadge}>{roleLabel(member.role)}</span>
                  </td>
                  <td>
                    <span className={member.isActive ? styles.activeBadge : styles.inactiveBadge}>
                      {member.isActive ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td>
                    <div className={styles.actionGroup}>
                      <button className={styles.editBtn} onClick={() => openEdit(member)}>
                        Editar
                      </button>
                      <button
                        className={styles.deleteBtn}
                        onClick={() => handleDelete(member.id, member.name || member.email)}
                      >
                        Eliminar
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {showModal && (
        <StaffForm onClose={closeModal} onSuccess={fetchStaff} staff={editStaff || undefined} />
      )}
    </div>
  );
}
